<template>
    <svg viewBox="0 0 60 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_16605_236751)">
            <path
                d="M33.0359 5.16357C27.6471 5.16357 23.5703 9.35696 23.5703 14.5518C23.5703 20.0282 27.8189 23.9399 33.0359 23.9399C38.2528 23.9399 42.4858 20.0282 42.4858 14.5518C42.4858 9.35696 38.4247 5.16357 33.0359 5.16357ZM33.0359 10.1237C35.3632 10.108 37.2688 12.0952 37.2688 14.5518C37.2688 16.9927 35.3632 18.9799 33.0359 18.9799C30.7085 18.9799 28.8029 16.9927 28.8029 14.5518C28.8029 12.0952 30.7085 10.1237 33.0359 10.1237Z"
                fill="black"
            />
            <path
                d="M60.0017 20.6535C60.0017 22.4686 58.5334 23.9394 56.7215 23.9394C54.9097 23.9394 53.4414 22.4686 53.4414 20.6535C53.4414 18.8385 54.9097 17.3677 56.7215 17.3677C58.5334 17.3677 60.0017 18.8385 60.0017 20.6535Z"
                fill="black"
            />
            <path d="M50.4514 23.314H45.2969V0H50.4514V23.314Z" fill="black" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 23.314L9.37183 0H14.2139L23.4296 23.314H16.8693L15.7759 20.0281H7.65366L6.56028 23.314H0ZM14.2139 15.1776H9.37183L11.7929 7.35408L14.2139 15.1776Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_16605_236751">
                <rect width="60" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
